"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = __importStar(require("styled-components"));
// TODO: add optional contrast attribute to typography elements
// body
exports.BodyJumbo = styled_components_1.default.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-family: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    font-weight: ", ";\n"], ["\n    font-family: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    font-weight: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.typography.bodyJumbo.fontFamily;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.bodyJumbo.fontSize;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.bodyJumbo.lineHeight;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.bodyJumbo.fontWeight;
});
exports.Body = styled_components_1.default.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-family: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    font-weight: ", ";\n"], ["\n    font-family: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    font-weight: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.typography.body.fontFamily;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.body.fontSize;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.body.lineHeight;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.body.fontWeight;
});
exports.BodyBig = styled_components_1.default.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-family: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    font-weight: ", ";\n"], ["\n    font-family: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    font-weight: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.typography.bodyBig.fontFamily;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.bodyBig.fontSize;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.bodyBig.lineHeight;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.bodyBig.fontWeight;
});
exports.BodyBold = styled_components_1.default.span(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    font-family: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    font-weight: ", ";\n"], ["\n    font-family: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    font-weight: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.typography.bodyBold.fontFamily;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.bodyBold.fontSize;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.bodyBold.lineHeight;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.bodyBold.fontWeight;
});
exports.BodySmall = styled_components_1.default.span(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    font-family: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    font-weight: ", ";\n"], ["\n    font-family: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    font-weight: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.typography.bodySmall.fontFamily;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.bodySmall.fontSize;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.bodySmall.lineHeight;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.bodySmall.fontWeight;
});
exports.BodySmallBold = styled_components_1.default.span(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    font-family: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    font-weight: ", ";\n"], ["\n    font-family: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    font-weight: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.typography.bodySmallBold.fontFamily;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.bodySmallBold.fontSize;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.bodySmallBold.lineHeight;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.bodySmallBold.fontWeight;
});
exports.BodyMicro = styled_components_1.default.span(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    font-family: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    font-weight: ", ";\n"], ["\n    font-family: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    font-weight: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.typography.bodyMicro.fontFamily;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.bodyMicro.fontSize;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.bodyMicro.lineHeight;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.bodyMicro.fontWeight;
});
exports.Notification = styled_components_1.default.span(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    font-family: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    font-weight: ", ";\n"], ["\n    font-family: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    font-weight: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.typography.notification.fontFamily;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.notification.fontSize;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.notification.lineHeight;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.notification.fontWeight;
});
exports.NotificationBold = styled_components_1.default.span(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    font-family: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    font-weight: ", ";\n"], ["\n    font-family: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    font-weight: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.typography.notificationBold.fontFamily;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.notificationBold.fontSize;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.notificationBold.lineHeight;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.notificationBold.fontWeight;
});
// attribution
exports.Quote = styled_components_1.default.span(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    font-family: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    font-weight: ", ";\n"], ["\n    font-family: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    font-weight: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.typography.quote.fontFamily;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.quote.fontSize;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.quote.lineHeight;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.quote.fontWeight;
});
exports.Author = styled_components_1.default.span(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    font-family: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    font-weight: ", ";\n"], ["\n    font-family: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    font-weight: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.typography.author.fontFamily;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.author.fontSize;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.author.lineHeight;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.author.fontWeight;
});
var baseCodeStyles = function (_) { return styled_components_1.css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    font-family: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    font-weight: ", ";\n    background-color: ", ";\n    color: ", ";\n"], ["\n    font-family: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    font-weight: ", ";\n    background-color: ",
    ";\n    color: ",
    ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.typography.code.fontFamily;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.code.fontSize;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.code.lineHeight;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.code.fontWeight;
}, function (_a) {
    var theme = _a.theme, variant = _a.variant;
    return variant === 'dark' ? theme.typography.code.contrastBackgroundColor : 'transparent';
}, function (_a) {
    var theme = _a.theme, variant = _a.variant;
    return variant === 'dark' ? theme.typography.code.contrastColor : 'auto';
}); };
// code
exports.Code = styled_components_1.default.pre(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    ", "\n\n    padding: ", ";\n"], ["\n    ", "\n\n    padding: ", ";\n"])), baseCodeStyles, function (_a) {
    var theme = _a.theme;
    return theme.typography.code.padding;
});
// inline code
exports.InlineCode = styled_components_1.default.code(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    ", "\n\n    padding: 0 ", ";\n    margin: 0 ", ";\n"], ["\n    ", "\n\n    padding: 0 ", ";\n    margin: 0 ", ";\n"])), baseCodeStyles, function (_a) {
    var theme = _a.theme;
    return theme.spacing.xxs;
}, function (_a) {
    var theme = _a.theme;
    return theme.spacing.xxs;
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14;
//# sourceMappingURL=typography.js.map